export default "__VITE_ASSET__BjPGtYXu__"